import { Record } from 'immutable';

const DriveTrainRecord = Record({
    trimsBitField: 0,
    trimsBitFields: [],
    selectionCode: '',
    code: '',
    rank: 0,
    description: '',
    longDescription: '',
});

class DriveTrain extends DriveTrainRecord {
    getSelectionCode() {
        return this.get('selectionCode');
    }
}

export default DriveTrain;
